/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


    // --- Free Gift Logic (Shared Function) ---
  function updateFreeGiftBar(cart) {
    const threshold = 100;
    const giftVariantId = 50673782391078;
    let cartTotal = cart.total_price / 100;
    let hasGift = cart.items.some(item => item.variant_id === giftVariantId);
    let amountRemaining = (threshold - cartTotal).toFixed(2);

    const bar = document.getElementById('freeGiftBar');
    if (!bar) return;

    const notQualified = bar.querySelector('.free-gift__not-qualified');
    const qualifiedNoGift = bar.querySelector('.free-gift__qualified-no-gift');
    const qualifiedWithGift = bar.querySelector('.free-gift__qualified-with-gift');
    const amountRemainingEl = bar.querySelector('#amountRemaining');

    if (notQualified) notQualified.style.display = 'none';
    if (qualifiedNoGift) qualifiedNoGift.style.display = 'none';
    if (qualifiedWithGift) qualifiedWithGift.style.display = 'none';

    if (cartTotal < threshold) {
      if (notQualified) notQualified.style.display = 'flex';
      if (amountRemainingEl) amountRemainingEl.textContent = `$${amountRemaining}`;
    } else {
      if (hasGift && qualifiedWithGift) {
        qualifiedWithGift.style.display = 'flex';
      } else if (!hasGift && qualifiedNoGift) {
        qualifiedNoGift.style.display = 'flex';
      }
    }
  }

  


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator

      updateFreeGiftBar(cart);
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
    
    if (e.detail && e.detail.cart) {
      updateFreeGiftBar(e.detail.cart);
    }
    
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
